// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ozw0","top":"styles_top__1EpL3","left":"styles_left__1JE4h","description":"styles_description__2A6g8"};